import { render, staticRenderFns } from "./NbaSuggestions.vue?vue&type=template&id=8bd5fbb4&scoped=true"
import script from "./NbaSuggestions.vue?vue&type=script&lang=js"
export * from "./NbaSuggestions.vue?vue&type=script&lang=js"
import style0 from "./NbaSuggestions.vue?vue&type=style&index=0&id=8bd5fbb4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd5fbb4",
  null
  
)

export default component.exports